import { FormGroup, Input, Label } from "reactstrap";
import { CommonUserFormGroupType } from "../../../../Type/UserType";

const CommonUserFormGroup = ({ type, title, placeholder,defaultValue,row }: CommonUserFormGroupType) => {
  return (
    <FormGroup>
      <Label check>{title}</Label>
      <Input type={type} placeholder={placeholder} autoComplete="" defaultValue={defaultValue} rows={row} />
    </FormGroup>
  );
};

export default CommonUserFormGroup;
